export default "__VITE_ASSET__kzyZ$mCt__"